import { render, staticRenderFns } from "./MiniWatchlist.vue?vue&type=template&id=fa1c380a"
import script from "./MiniWatchlist.vue?vue&type=script&lang=js"
export * from "./MiniWatchlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa1c380a')) {
      api.createRecord('fa1c380a', component.options)
    } else {
      api.reload('fa1c380a', component.options)
    }
    module.hot.accept("./MiniWatchlist.vue?vue&type=template&id=fa1c380a", function () {
      api.rerender('fa1c380a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MiniWatchlist.vue"
export default component.exports